import { useLivekitStore } from '../../stores/livekitStore'

/**
 * Shown when the user tries to JOIN a call in this tab while ANOTHER browser
 * tab already owns the live call (single-instance guard, callInstanceGuard.ts).
 * Discord-style "block + use here": by default the other tab keeps the call;
 * "Перейти сюда" takes it over here. Auto-reconnect joins pass silentIfBlocked
 * and never reach this modal.
 */
export default function CallTabBlockModal() {
  const blocked = useLivekitStore((s) => s.blockedByOtherTab)
  const takeover = useLivekitStore((s) => s.takeoverCallHere)
  const clear = useLivekitStore((s) => s.clearBlockedByOtherTab)

  if (!blocked) return null

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/60"
      role="dialog"
      aria-modal="true"
    >
      <div className="w-[min(92vw,380px)] rounded-xl border border-border bg-card p-5 text-foreground shadow-xl">
        <h2 className="mb-1 text-base font-semibold">Звонок уже идёт в другой вкладке</h2>
        <p className="mb-4 text-sm text-muted-foreground">
          Микрофон и звук работают там. Чтобы не было эха и нагрузки, звонок
          держится в одной вкладке. Можно перенести его сюда.
        </p>
        <div className="flex justify-end gap-2">
          <button
            onClick={clear}
            className="rounded-md bg-muted px-3 py-1.5 text-sm text-foreground transition hover:bg-muted/80"
          >
            Отмена
          </button>
          <button
            onClick={() => { void takeover() }}
            className="rounded-md bg-primary px-3 py-1.5 text-sm text-primary-foreground transition hover:bg-primary/90"
          >
            Перейти сюда
          </button>
        </div>
      </div>
    </div>
  )
}
